module.exports = __webpack_public_path__ + "static/media/2.12a994f2.jpg";